import { render, staticRenderFns } from "./IconSys.vue?vue&type=template&id=0ae687d8&scoped=true"
import script from "./IconSys.vue?vue&type=script&lang=js"
export * from "./IconSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae687d8",
  null
  
)

export default component.exports